<sc-padding fitHeight>
  <sc-flex fitHeight stretchContent>
    <sc-flex-fitting-content>
      <sc-tab-group noContent (tabChanged)="handleActiveTab($event)">
        <sc-tab titleDictionaryKey="include" key="include" (click)="included = true"></sc-tab>
        <sc-tab titleDictionaryKey="exclude" key="exclude" (click)="included = false"></sc-tab>
      </sc-tab-group>
      <sc-scroll-pane>
        <app-truck-group-condition-station (click)="selectAssignedStations(station)"
          *ngFor="let station of assignedStations" [station]="station" [selectedStations]="selectedAssignedStations">
        </app-truck-group-condition-station>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-content-spacer></sc-content-spacer>
    <sc-flex vertical centered fitHeight>
      <sc-button dictionaryKey="add" [disabled]="selectedAvaiableStations.size == 0" (click)="addStation()"></sc-button>
      <sc-content-spacer vertical=""></sc-content-spacer>
      <sc-button dictionaryKey="remove" [disabled]="selectedAssignedStations.size == 0"
        (click)="removeStation()"></sc-button>
    </sc-flex>
    <sc-content-spacer></sc-content-spacer>
    <sc-flex-fitting-content>
      <sc-flex vertical fitHeight stretchContent>
        <sc-text-label labelDictionaryKey="Stations"></sc-text-label>
        <sc-flex-fitting-content vertical>

          <sc-scroll-pane>
            <app-truck-group-condition-station (click)="selectAvaiableStations(station)"
              *ngFor="let station of avaiableStations" [station]="station"
              [selectedStations]="selectedAvaiableStations">
            </app-truck-group-condition-station>
          </sc-scroll-pane>
        </sc-flex-fitting-content>

      </sc-flex>
    </sc-flex-fitting-content>
  </sc-flex>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="onCancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button (click)="onConfirm()"></sc-confirm-button>
  </sc-actionbar>
</sc-padding>